/**
 * @Author: v_jppjpeng
 * @Date: 2023-05-24 18:08:02
 * @Explain: 发送验证码
 */
import { intlGet } from '@/locales';
import GoogleVerify from '@/pages/adminManage/components/googleVerify';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Input } from 'tdesign-react';
import Button from '../button';
import CountDown from './countDown';

type PropsType = {
  value?: any;
  placeholder?: string;
  countdownNum?: number;
  defaultBtnDisabled?: boolean;
  onChange?: (val: string) => void;
  onBlur?: () => void;
  isSending?: boolean;
  onSendCode?: ({
    captchaToken,
    successCallBack,
    errorCallBack,
  }: {
    captchaToken: string;
    successCallBack: () => void;
    errorCallBack: () => void;
  }) => void;
};
function SendVerifyCode(props: PropsType, refs: any) {
  const {
    value,
    placeholder,
    countdownNum = 60,
    defaultBtnDisabled = true,
    onChange,
    onSendCode,
  } = props;

  // 谷歌验证v2
  const [googleVerifyV2, setGoogleVerifyV2] = useState(false);
  // 谷歌验证码
  const [captchaToken, setCaptchaToken] = useState('');
  // 按钮loading
  const [btnLoading, setBtnLoading] = useState(false);
  // 按钮是否禁用
  const [btnDisabled, setBtnDisabled] = useState(defaultBtnDisabled);
  // 是否发送成功
  const [isSending, setIsSending] = useState(false);
  // 倒计时
  const [countdownSeconds, setCountdownSeconds] = useState(countdownNum);

  const successCallBack = () => {
    setBtnLoading(false);
    setBtnDisabled(true);
    setIsSending(true);
    // 因为谷歌验证码只能用一次，所以要清除
    setCaptchaToken('');
  };
  const errorCallBack = () => {
    setBtnLoading(false);
    setBtnDisabled(false);
    setCaptchaToken('');
  };

  // 绑定ref，抛出方法
  useImperativeHandle(refs, () => ({
    setBtnDisabled: (val: boolean) => {
      if (!isSending) {
        setBtnDisabled(val);
      }
    },
    setBtnLoading,
    successCallBack,
    errorCallBack,
  }));

  return (
    <>
      <Input placeholder={placeholder} value={value} onChange={onChange} />
      <Button
        shape="rectangle"
        variant="outline"
        loading={btnLoading}
        disabled={btnDisabled}
        onClick={() => {
          if (captchaToken) {
            setBtnLoading(true);
            onSendCode?.({
              captchaToken,
              successCallBack,
              errorCallBack,
            });
          } else {
            setGoogleVerifyV2(true);
          }
        }}
        style={{
          borderRadius: 8,
        }}
      >
        {isSending ? (
          <CountDown
            seconds={countdownSeconds}
            onTick={setCountdownSeconds}
            onComplete={() => {
              setIsSending(false);
              setBtnDisabled(false);
              setCountdownSeconds(countdownNum);
            }}
          />
        ) : btnLoading ? (
          ''
        ) : (
          intlGet('COMMON.SEND.CODE')
        )}
      </Button>
      {/* 谷歌验证 */}
      {googleVerifyV2 &&
        <GoogleVerify
          visible={googleVerifyV2}
          onClose={() => setGoogleVerifyV2(false)}
          onChange={(val: any) => {
            setCaptchaToken(val);
            setBtnLoading(true);
            onSendCode?.({
              captchaToken: val,
              successCallBack,
              errorCallBack,
            });
          }}
        />}
    </>
  );
}

export default forwardRef(SendVerifyCode);
